<form (ngSubmit)="save()">
	<section #rootElement class="billboard" tabindex="-1">
		<div class="billboard-header">
			<h2 class="billboard-title">
				Family and Support

				<ng-container
					*ngTemplateOutlet="
						requiresProof;
						context: {
							$implicit: proofMap.get('personal'),
						}
					"
				/>
			</h2>
			<div class="billboard-actions">
				<div class="btn-toolbar">
					<button
						class="btn btn-secondary"
						id="profile.contact.edit.cancel"
						type="button"
						(click)="contactSaveListener(false)"
					>
						Cancel
					</button>
					<button
						class="btn btn-primary"
						id="profile.contact.edit.enable"
						type="submit"
						[disabled]="
							savingInfo || !profileContactFormGroup.valid || !hasChanges
						"
					>
						Save Changes
					</button>
				</div>
			</div>
		</div>
		<div class="billboard-body">
			@if (ageGate === true && primaryContactIndex == null) {
				<div class="alert alert-info">
					<i aria-hidden="true" class="fas fa-exclamation-triangle"></i> A
					primary guardian is required to save the contact info for this student
				</div>
			}
			@for (
				item of profileContactFormGroup.controls;
				track item;
				let i = $index;
				let last = $last
			) {
				<ng-container [formGroup]="item">
					@if (item.controls.delete.value === false) {
						<div>
							<div class="row">

								<!-- Name -->
								<div aeGroupValidation class="col-xl-6 form-group">
									<ae-form-label
										for="profile.contact.edit.name.{{ i }}"
										label="Name"
										required
									/>
									<input
										autocomplete="off"
										class="form-control"
										formControlName="name"
										id="profile.contact.edit.name.{{ i }}"
										placeholder="Name"
										type="text"
									/>
									<ae-group-validation-display [maxDisplay]="1">
										<ng-template aeValidationError="required">
											A full name is required
										</ng-template>
									</ae-group-validation-display>
								</div>

								<!-- Relationship -->
								<div aeGroupValidation class="col-xl-3 col-sm-6 form-group">
									<ae-form-label
										for="profile.contact.edit.relationship.{{ i }}"
										label="Relationship"
										required
									/>
									<ng-select
										bindLabel="value"
										bindValue="key"
										formControlName="relationship"
										labelForId="profile.contact.edit.relationship.{{ i }}"
										required
										[clearable]="false"
										[items]="formattedDropdownRelationship"
									/>
									<ae-group-validation-display [maxDisplay]="1">
										<ng-template aeValidationError="required">
											A relationship is required
										</ng-template>
									</ae-group-validation-display>
								</div>
								@if (
									profileContactFormGroup.controls[i].controls.relationship
										.value === 'Other'
								) {

									<!-- Describe Relationship -->
									<div aeGroupValidation class="col-xl-3 col-sm-6 form-group">
										<ae-form-label
											for="profile.contact.edit.description.{{ i }}"
											label="Describe Relationship"
											required
										/>
										<input
											autocomplete="off"
											class="form-control"
											formControlName="describeRelationship"
											id="profile.contact.edit.description.{{ i }}"
											placeholder="Describe Relationship"
											type="text"
										/>
										<ae-group-validation-display [maxDisplay]="1">
											<ng-template aeValidationError="required">
												A relationship description is required
											</ng-template>
										</ae-group-validation-display>
									</div>
								}
							</div>
							<div class="row">
								<div class="col-xl-6">
									@for (
										phone of profileContactFormGroup.controls[i].controls.phone
											.controls;
										track phone;
										let phoneFirst = $first;
										let phoneIndex = $index
									) {
										<div class="row">

											<!-- Number -->
											<div
												aeGroupValidation
												class="col-xl-4 col-md-6 form-group"
											>
												<ae-form-label
													class="d-flex"
													for="profile.contact.edit.number.{{ i }}.{{
														phoneIndex
													}}"
													label="Number"
													[required]="
														hasRequiredValidator(
															profileContactFormGroup.controls[i].controls.phone
																.controls[phoneIndex]
														)
													"
												>
													@if (!phoneFirst) {
														<button
															class="btn btn-icon"
															title="Delete this phone number"
															type="button"
															(click)="deletePhone(i, phoneIndex)"
														>
															<i aria-hidden="true" class="fas fa-times"></i>
														</button>
													}
												</ae-form-label>
												<input
													autocomplete="off"
													class="form-control"
													id="profile.contact.edit.number.{{ i }}.{{
														phoneIndex
													}}"
													placeholder="Number"
													type="tel"
													[formControl]="phone.controls.number"
												/>
												<ae-group-validation-display [maxDisplay]="1">
													<ng-template aeValidationError="notsevendigitphone">
														Must be a 10 digit phone number
													</ng-template>
													<ng-template aeValidationError="phone">
														Must be a phone number
													</ng-template>
													<ng-template aeValidationError="required">
														Phone number is required
													</ng-template>
												</ae-group-validation-display>
											</div>

											<!-- Type -->
											<div class="col-xl-4 col-md-3 col-6 form-group">
												<label
													for="profile.contact.edit.type.{{ i }}.{{
														phoneIndex
													}}"
												>
													Type
												</label>
												<ng-select
													bindLabel="value"
													bindValue="key"
													labelForId="profile.contact.edit.type.{{ i }}.{{
														phoneIndex
													}}"
													[formControl]="phone.controls.type"
													[items]="formattedDropdownPhoneType"
												/>
											</div>

											<!-- SMS -->
											<div class="col-xl-4 col-md-3 col-6 form-group">
												<div class="label-spacer d-block">&nbsp;</div>
												<ae-input-checkbox
													id="profile.contact.edit.sms.{{ i }}.{{ phoneIndex }}"
													[formControl]="phone.controls.sms"
												>
													SMS
												</ae-input-checkbox>
											</div>
										</div>
									}
								</div>
								<div class="col-xl-6">
									@for (
										email of profileContactFormGroup.controls[i].controls.email
											.controls;
										track email;
										let emailIndex = $index;
										let emailFirst = $first
									) {

										<!-- Email -->
										<div aeGroupValidation class="form-group">
											<ae-form-label
												class="d-flex"
												for="profile.contact.edit.email.{{ i }}.{{
													emailIndex
												}}"
												label="Email"
												[required]="
													hasRequiredValidator(
														profileContactFormGroup.controls[i].controls.email
															.controls[emailIndex]
													)
												"
											>
												@if (!emailFirst) {
													<button
														class="btn btn-icon"
														title="Delete this email address"
														type="button"
														(click)="deleteEmail(i, emailIndex)"
													>
														<i aria-hidden="true" class="fas fa-times"></i>
													</button>
												}
											</ae-form-label>
											<input
												autocomplete="off"
												class="form-control"
												id="profile.contact.edit.email.{{ i }}.{{ emailIndex }}"
												placeholder="Email"
												type="text"
												[formControl]="email.controls.email"
											/>
											<ae-group-validation-display [maxDisplay]="1">
												<ng-template aeValidationError="email">
													Must be a valid email address
												</ng-template>
												<ng-template aeValidationError="required">
													An email is required for parent account.
												</ng-template>
											</ae-group-validation-display>
										</div>
									}
								</div>
							</div>
							<div class="row">
								<div class="col-xl-12 d-flex">
									<div class="flex-grow-1">
										<label>
											<input
												class="screen-reader-text"
												title="{{
													i === primaryContactIndex
														? 'Primary Contact'
														: 'Set as Primary Contact'
												}}"
												type="checkbox"
												[disabled]="savingInfo"
												(click)="setPrimaryContact(i)"
											/>
											@switch (i === primaryContactIndex) {
												@case (true) {
													<i
														aria-hidden="true"
														class="fas fa-check-square pointer"
													></i>
												}
												@default {
													<i
														aria-hidden="true"
														class="far fa-square pointer"
													></i>
												}
											}
											<span class="unselectable pointer">
												Is Primary Parent or Guardian
											</span>
										</label>
									</div>
									<button
										class="btn btn-default"
										id="profile.contact.edit.address.{{ i }}.delete"
										type="button"
										[disabled]="savingInfo"
										(click)="deleteContact(i)"
									>
										Delete Contact
									</button>
								</div>
							</div>
							<hr />
						</div>
					}
				</ng-container>
			}
			<div class="text-center">
				<button class="btn btn-default" type="button" (click)="addContact()">
					Add Contact
				</button>
			</div>
		</div>
	</section>
</form>

<ng-template #requiresProof let-item>
	@if (item?.proof_requirement?.required) {
		<i
			aria-hidden="true"
			class="fas fa-triangle-exclamation text-danger"
			ngbTooltip="This field requires proof to update. You will be asked to provide documentation when you save."
		></i>
	}
</ng-template>
